<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col gap-3">
    <!-- Throwaway: one-shot Program Product Reconcile feature. Diff-only (v1). -->

    <div class="flex flex-row items-center gap-3">
      <p-button (onClick)="reload()" label="Refresh" icon="pi pi-refresh" size="small" [outlined]="true"></p-button>
      <div *ngIf="loading" class="flex items-center gap-2 text-blue-700">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading diff against Uniformax...</span>
      </div>
      <div *ngIf="!loading && dto && !dto.Unmatched" class="flex flex-row gap-4 ml-2 items-center">
        <span class="font-semibold text-green-700">{{ dto.MatchCount }} matches</span>
        <span class="font-semibold text-red-700">{{ dto.OrphanCount }} orphans</span>
        <span *ngIf="dto.IsIssuanceOnly" class="font-semibold text-red-700">{{ dto.UnconstrainedCount }} unconstrained</span>
        <span class="font-semibold text-blue-700">{{ dto.MissingCount }} missing</span>
        <span *ngIf="dto.IsIssuanceOnly"
          class="text-xs uppercase tracking-wide px-2 py-0.5 rounded bg-gray-200 text-gray-700">
          Issuance-Only Program
        </span>
      </div>
    </div>

    <div *ngIf="!loading && dto?.Unmatched"
      class="p-4 border border-amber-400 bg-amber-50 rounded text-amber-900">
      <div class="font-semibold mb-1">No matching Uniformax program found.</div>
      <div>{{ dto?.UnmatchedReason || 'Account or program name did not match exactly in the legacy Uniformax DB.' }}</div>
    </div>

    <div *ngIf="!loading && dto && !dto.Unmatched" class="grow flex flex-col">
      <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[55, 45]">
        <ng-template pTemplate>
          <div class="h-full w-full flex flex-col">
            <div class="flex flex-row items-center gap-3 mb-2">
              <div class="qb-group-label">Proximity: current rows on this program (red = orphan or unconstrained)</div>
              <p-button *ngIf="dto.OrphanCount > 0"
                (onClick)="onRemoveAllOrphans()"
                [label]="'Delete All Orphans (' + dto.OrphanCount + ')'"
                icon="pi pi-trash"
                severity="danger"
                size="small"></p-button>
            </div>
            <div class="grow w-full">
              <prox-ag-grid gridId="reconcileProxGrid" [gridOptions]="proxGridOptions"
                [rowData]="dto.ProximityRows"></prox-ag-grid>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div class="h-full w-full flex flex-col">
            <div class="qb-group-label mb-2">Uniformax: authoritative rows for this program (blue = missing in Proximity)</div>
            <div class="grow w-full">
              <prox-ag-grid gridId="reconcileUfxGrid" [gridOptions]="ufxGridOptions"
                [rowData]="dto.UniformaxRows"></prox-ag-grid>
            </div>
          </div>
        </ng-template>
      </p-splitter>
    </div>
  </div>
</div>
